export const clearLoading = () => ({
  type: 'CLEAR_LOADING',
})

export const setLoading = (loading) => ({
  loading,
  type: 'SET_LOADING',
})
